<template>
  <div v-if="!isOpen" class="company-chat-box">
    <div class=" d-flex justify-content-center align-items-end">
      <div class="content-wrapper">
        <div class="pre-header d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center ">
            <img class="image" :src="globalData.setting.live_chat.avatar" alt=""/>
            <div class="name ml-2 trim-text-line-one">{{ globalData.setting.live_chat.name }}</div>
          </div>
          <div class="d-flex align-items-center justify-content-center close-icon" @click="closePopup">
            <b-icon variant="light" icon="chevron-down" aria-hidden="true" scale="1.6" ra></b-icon>
          </div>
        </div>

        <div v-if="globalData.setting.is_required_field">
          <chat-form></chat-form>
        </div>

        <div v-else>
          <div class="chat-content-body scrollbar scrollbar-hidden">
            <infinite-loading ref="infiniteLoading" direction="top" @infinite="getListMessage">
              <div slot="spinner"></div>
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
            <msg-notification v-if="globalData.setting?.live_chat?.description && this.skip_number === 0" :content="globalData.setting?.live_chat?.description" class="mb-2"></msg-notification>
            <div v-if="list_message.filter(p=>p.from?.id !== globalData.account_id).length > 0">
              <div v-for="(msg, index) in list_message" :key="index">
                <div v-if="showTime(msg, index)" class="text-center my-1">
                  <small v-html="timeToString(msg.created_at)"></small>
                </div>
                <msg-text class="margin-c" v-if="msg.message.type === 'text'" :msg="msg" :cls="addCls(msg)" :is-me="checkIsMe(msg)" :show-avatar="checkAvatar(msg, index)"></msg-text>
                <msg-image class="margin-c" v-if="msg.message.type === 'media'" :msg="msg" :cls="addCls(msg)" :is-me="checkIsMe(msg)" :show-avatar="checkAvatar(msg, index)"></msg-image>
              </div>
            </div>
            <div v-else v-show="delayRender">
              <div class= "pb-2">
                <msg-text v-if="list_message[0]?.message?.type === 'text'" :msg="list_message[0]" :cls="addCls(list_message[0])" :is-me="checkIsMe(list_message[0])" :show-avatar="checkAvatar(list_message[0], index)"></msg-text>
                <div v-if="globalData.setting.questions_list.length > 0" class="question">
                  <div v-for="(content, index) in globalData.setting.questions_list" :key="'question'+index">
                    <div class="question-item" @click="handleQuestion(content)">{{ content }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div id="end-point"></div>
          </div>
          <div class="chat-input d-flex align-items-center justify-content-between px-2">
            <b-input class="input" v-model="message_content" placeholder="Nhập tin nhắn" @keydown.enter="handleEnter()" autocomplete="off"></b-input>

            <b-icon-link45deg scale="1.5" variant="primary" style="margin-top: 6px; margin-right: 4px" class="pointer" @click="$refs.select_file.click()"></b-icon-link45deg>

            <b-dropdown dropup dropright id="dropdown-emoji" no-caret variant="link"
                        toggle-class="text-decoration-none m-0 p-0" style="margin-top: 4px; margin-left: 2px">
              <template #button-content>
                <b-icon-emoji-smile scale="1" @click="closePopover"></b-icon-emoji-smile>
              </template>
              <Picker style="height: 35vh" :data="emoji_index" set="apple" @select="showEmoji" :perLine="9"
                      :showPreview="false" :showSearch="false" :showCategories="true"/>
            </b-dropdown>
            <input ref="select_file" type="file" v-show="false" accept=".png, .jpg, .jpeg" multiple @change="openFileExplorer()">
          </div>
        </div>
        <div v-if="url_picture_template.length > 0" class="image-template">
          <div v-for="image in url_picture_template" :key="image" class="image-thumb">
            <img :src="image" class="image">
            <b-icon-x-circle-fill class="delete" @click="deleteImage(image)"></b-icon-x-circle-fill>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import api from "@/lib/callAPI"
import moment from "moment-timezone";
import MsgNotification from "@/views/components/chat-content/MsgNotification.vue";
import MsgText from "@/views/components/chat-content/MsgText.vue";
import ChatForm from "@/views/components/ChatForm.vue";
import index from "v-viewer";
import MsgImage from "@/views/components/chat-content/MsgImage.vue";
import {Picker, EmojiIndex} from "emoji-mart-vue-fast";
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import InfiniteLoading from 'vue-infinite-loading';
import util from "@/lib/util";
let emoji_index = new EmojiIndex(data);
export default {
  name: 'ChatPopup',
  computed: {
    index() {
      return index
    }
  },
  components: {Picker, InfiniteLoading, MsgImage, MsgNotification, MsgText, ChatForm},
  watch: {
    'isOpen' :  function (){
      this.skip_number = 0;
      this.list_message = [];
    }
  },
  created() {
  },
  mounted() {
    this.$root.$on('openChat', async data =>{
      await this.handleOpenChat(data.content)
    });
    this.$root.$on('addNewMessage', async data =>{
      this.appendMessage(data)
    })
  },
  props: ['isOpen'],
  data() {
    return {
      delayRender: false,
      name: '',
      phone: '',
      mail: '',
      interest_content: '',

      emoji_index: emoji_index,
      list_message: [],
      message_content: '',
      message_open_chat : {},
      skip_number: 0,

      url_picture_template: [],
    }
  },

  methods: {

    deleteImage(image){
      this.url_picture_template = this.url_picture_template.filter(p=>p !== image)
    },

    async openFileExplorer(){
      for (let file of event.target.files) {
        if (!file) return;
        if (file.size > 9437184) {
          return this.sendToast('danger', 'Dung lượng ảnh lớn hơn 9MB');
        }
        let url = URL.createObjectURL(file);
        this.url_picture_template.push(url)
      }
    },

    async getListMessage($state){
      this.delayRender = false;
      setTimeout(() => {
        this.delayRender = true;
      }, 300);
      const body =  {
        conversation_id: this.globalData.browser_id,
        account_id: this.globalData.account_id,
        skip_number : this.skip_number
      }
      const response =  await api.post('/api/conversation/getMessages', body, this.globalData.params);
      if(response.success === true){
        if(response.data?.data?.length > 0){
          this.globalData.browser_id = response.data.data[0]?._id?.conversation_id;
        }
        this.list_message.unshift(...response.data.data.reverse());
        if(this.skip_number === 0){
          this.scrollToDiv('end-point');
        }
        this.skip_number = response.data.skip_number;
        if(this.skip_number === 0){
          $state.complete();
        }else {
          $state.loaded();
        }
      }
      if(this.list_message.length === 0){
        if(this.globalData.setting?.greeting?.length > 0){
          const new_message = this.generateNewMessage({message: this.globalData.setting.greeting, urls : [], from_id: this.globalData.account_id});
          this.appendMessage(new_message);
          this.message_open_chat = new_message;
        }
        $state.complete();
      }
    },

    async sendMessage(message, is_account = false) {
      const body = {
        _id: message._id,
        company_code : this.globalData.company_code,
        type: 'text',
        message: message.message.content.message,
        customer_info: this.globalData.required_field,
        is_account: is_account
      }
      await api.post('/api/conversation/sendTextMessage', body, this.globalData.params).then()
    },

    async sendAttachMedia() {
      let list_image = this.url_picture_template
      this.url_picture_template = []
      for (let image of list_image) {

        if (image) {

          let appendMessage = this.generateNewMessage({urls: [image]});

          this.appendMessage(appendMessage);

          let readFile = null

          if( image.includes('blob') ){
            readFile = await this.readFileBase64(image, 1920, 1920)
          }

          const body = {
            _id: appendMessage._id,
            company_code : this.globalData.company_code,
            type_content: 'image',
            file_info: image,
            customer_info: this.globalData.required_field,
            file_base64: readFile?.base64?.substr(readFile?.base64?.indexOf(',') + 1),
            file_type: readFile?.type
          }

          await new Promise(resolve => setTimeout(resolve, 2000));

          api.post('/api/conversation/sendMediaMessage', body, this.globalData.params).then();
        }
      }

      this.url_picture_template = []
    },

    async readFileBase64(url, maxWidth, maxHeight, quality = 0.9) {
      try {
        const { contentType, blob } = await this.getBlobAndContentType(url);
        const sizeInMB = blob.size / (1024 * 1024);

        if (contentType === 'image/png' || contentType === 'image/jpeg') {
          const adjustedQuality = sizeInMB > 2 ? quality : 1.0;
          const base64Image = await this.loadAndResizeImage(blob, maxWidth, maxHeight, contentType, adjustedQuality);
          return { base64: base64Image, type: contentType };
        } else {
          throw new Error('Unsupported media type: ' + contentType);
        }
      } catch (error) {
        throw new Error('Failed to convert media to base64: ' + error.message);
      }
    },

    getBlobAndContentType(url) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          const contentType = xhr.getResponseHeader('Content-Type');
          const blob = xhr.response;
          resolve({ contentType, blob });
        };
        xhr.onerror = function () {
          reject(new Error('Failed to get content type and blob'));
        };
        xhr.send();
      });
    },

    loadAndResizeImage(blob, maxWidth, maxHeight, contentType, quality) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = function () {
          const img = new Image();
          img.src = reader.result;

          img.onload = function () {
            let width = img.width;
            let height = img.height;

            if (width > maxWidth || height > maxHeight) {
              const ratio = Math.min(maxWidth / width, maxHeight / height);
              width = width * ratio;
              height = height * ratio;
            }

            // Tạo canvas để resize ảnh
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            let resizedBase64 = canvas.toDataURL(contentType);
            if( (resizedBase64.length / (1024 * 1024)) > 5 ){
              resizedBase64 = canvas.toDataURL(contentType, quality);
            }

            resolve(resizedBase64);
          };

          img.onerror = function () {
            reject(new Error('Failed to load image for resizing'));
          };
        };

        reader.onerror = function () {
          reject(new Error('Failed to read file as base64'));
        };

        reader.readAsDataURL(blob);
      });
    },

    async handleOpenChat(content){
      const new_message = this.generateNewMessage({ message: content, urls : []})
      this.appendMessage(new_message);
      await this.sendMessage(new_message);
    },

    handleEnter(){
      if(this.message_content.trim().length === 0 && this.url_picture_template.length === 0){
        return
      }
      if(this.message_content.trim().length > 0){
        const new_message = this.generateNewMessage({message: this.message_content, urls : []})
        this.appendMessage(new_message);
        this.sendMessage(new_message);
        this.message_content = '';
      }
      if(this.url_picture_template.length > 0){
        this.sendAttachMedia()
      }
    },

    async handleQuestion(content){
      const new_message = this.generateNewMessage({ message: content, urls : []})
      this.appendMessage(new_message);
      if(this.message_open_chat._id){
        await this.sendMessage(this.message_open_chat, true);
      }
      await this.sendMessage(new_message);
    },

    appendMessage(message){
      this.list_message.push(message);
      this.scrollToDiv('end-point');
    },

    scrollToDiv(id) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center'});
          }
        }, 300);
      });
    },


    generateNewMessage({message, urls, from_id = undefined}){
      const message_id = util.generateRandomString(32)
      const new_message = {
        "_id": {
          "conversation_id": this.globalData.browser_id,
          "account_id": this.globalData.account_id,
          "channel": "LiveChat",
          "message_id": message_id
        },
        "from": {
          "id": from_id ? from_id: ''
        },
        "to": {
          "id": from_id ? '' : this.globalData.account_id,
        },
        "message": {
          "status": null,
          "order": {
            "code": null,
            "state": null
          },
          "content": {
            "message": message ||'',
            "attachment_data": [],
            "location": null
          },
          "type": "text",
          "quote_msg": null,
          "action_id": null,
          "unsent_at": null
        },
        "response_time": null,
        "channel_data": {},
        "source": "scan",
        "sw_account": null,
        "created_at": moment()
      }
      if(urls?.length > 0){
        for (const url of urls){
          new_message.message.content.attachment_data.push({ name: '', url: url, thumbnail: '', description: '', type: 'image' })
        }
        new_message.message.type = 'media';
      }
      return new_message
    },

    closePopup() {
      this.$emit('close-popup');
    },

    checkIsMe(msg){
      return this.globalData.account_id !== msg.from.id
    },

    addCls(msg) {
      let result = '';
      this.checkIsMe(msg) ? result += "block-right justify-content-end" : result += "block-left";
      return result;
    },

    checkAvatar(msg, index){
      console.log()
      return index === 0 || (msg.from.id === this.globalData.account_id && this.list_message[index - 1]?.from.id !== msg.from.id)
    },

    showTime(msg, index) {
      if (index === 0) {
        return true
      } else {
        let time = moment(msg.created_at)
        let time2 = moment(this.list_message[index - 1].created_at)
        return time.diff(time2, 'minutes') >= 60;
      }
    },

    timeToString(time) {
      return moment(time).lang('vi').format("dddd, DD/MM/YYYY, HH:mm").charAt(0).toUpperCase() + moment(time).lang('vi').format("dddd, DD/MM/YYYY, HH:mm").slice(1)
    },


    closePopover() {
      this.$refs.popover?.$emit('close')
    },

    showEmoji(emoji) {
      this.message_content = this.message_content + emoji.native;
    },
  }

};
</script>

<style lang="scss" scoped>

.trim-text-line-one {
  padding-left: 1px;
  color: #202125;
  flex: none;
  order: 0;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.company-chat-box {
  position: fixed;
  bottom: 10px;
  right: 66px;
  width: 360px!important;
  height: 560px!important;
  background-color: white;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  .content-wrapper {
    border-radius: 20px;

    .pre-header {
      display: flex;
      align-content: center;
      align-items: center;
      background-color: #1876ff;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      height: 80px;
      width: 360px!important;
      .image {
        width: 40px;
        height: 40px;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 50%;
        padding: 2px;
        background-color: #e7eaf4;
        margin-bottom: 0;
        margin-left: 20px;
      }

      .name {
        color: white;
        font-weight: 600;
        font-size: 18px;
        width: 180px;
      }
    }

    .chat-content-body {
      width: 360px!important;
      background-color: white;
      height: 400px;
      padding: 0px 4px;
      position: relative;
      overflow-y: scroll;
      .description {
        text-align: center;
      }

      .avatar {
        width: 28px;
        height: 28px;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 50%;
        padding: 0px;
        background-color: #e7eaf4;
        margin-bottom: 10px;
        margin-left: 10px;
      }

      .block-chat {
        background-color: #f3f4f5;
        max-width: 250px;
        padding: 8px;
        border-radius: 4px;
      }

      .question{
        justify-content: center;
        position: absolute;
        bottom: 5px;
        justify-items: center;
        width: 98%;
        .question-item{
          cursor: pointer;
          text-align: center;
          background-color: #d0eceb;
          padding: 6px;
          border-radius: 6px;
          margin-top: 2px;
          width: 300px;
          word-wrap: break-word;
          &:hover{
            background-color: #dcdedf;
          }
        }
      }
    }

    .chat-input {
      border-top: 1px solid #e5e8eb;
      background-color: white;
      height: 80px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .input{
        border: none;
        box-shadow: none;

      }
    }
  }

  .image {
    width: 60px;
    height: 60px;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 50%;
    padding: 2px;
    background-color: #e7eaf4;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}

.close-icon {
  height: 32px;
  width: 32px;
  cursor: pointer;
  border-radius: 16px;
  margin-right: 15px;

  &:hover{
    background-color: #89c4f4
  }
}

.image-template{
  display: flex;
  position: relative;
  z-index: 1001;
  top: -132px;
  justify-content: start;
  align-items: center;

  .image-thumb{
    position: relative;
    .image{
      width: 42px;
      height: 42px;
      border-radius: 4px;
      margin: 8px;
      border: 1px solid rgba(0, 0, 0, 0.35);
      box-shadow: rgba(0, 0, 0, 0.35) 0px 3px 3px;
    }
    .delete{
      position: absolute;
      color: rgba(0, 0, 0, 0.35);
      top: 2px;
      right: 2px;
    }
  }
  .text{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: absolute;
    top: 22px;
    right: 2px;
    color: white;
    background-color: #007bff;
    padding: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }
}
.margin-c{
  margin-bottom: 6px!important;
}
</style>